<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uE9zHr/images/9781466833937.jpg?1724536005863" alt="This image is the cover for the book Welding with Children"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Welding with Children
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A master storyteller's triumphant, moving collection about lost souls, found love, and rediscovered tradition</b><br/><br/>Tim Gautreaux returns to the form that won him his first fans, with tales of family, sin, and redemption: from a man who realizes his grandchildren are growing up without any sense of right or wrong, and he's to blame; to a camera repairman who uncovers a young woman's secret in the undeveloped film she brings him; to a one-armed hitch-hiker who changes the life of the man who gives her a ride.<br/><br/>Each one a small miracle of storytelling and compassion, these stories in <i>Welding with Children</i> are a joyous confirmation of Tim Gautreaux's rare and generous talent.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tim Gautreaux
      </h2>
      
      <p class="authorDescription body article"><B>Tim Gautreaux</B>'s work has appeared in <I>Harpers</I>,<I> The Atlantic Monthly</I>, <I>GQ</I>, <I>Story</I>, and <I>Be</I>s<I>t</I><I>American Short Stories</I>.  He is the author of <I>Welding with Children, Same Place, Same Things, </I>and <I>The Next Step in the Dance.</I> He lives in Hammond, Louisiana.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c6cbd38